import React, { useState } from 'react';
import { useRoutineProgress } from './graph/hooks/useRoutineProgress';
import { useWeeklyData } from './graph/hooks/useWeeklyData';
import { RoutineBarChart } from './graph/RoutineBarChart';
import { GraphHeader } from './graph/GraphHeader';
import { WeekNavigation } from './graph/WeekNavigation';
import { ProgressSummary } from './graph/ProgressSummary';

interface WeeklyRoutinesGraphProps {
  routines: any[];
}

export const WeeklyRoutinesGraph = ({ routines }: WeeklyRoutinesGraphProps) => {
  const [weekOffset, setWeekOffset] = useState(0);
  const { data: routineProgress } = useRoutineProgress(weekOffset);
  
  const {
    weekDays,
    totalCompletedRoutines,
    progressPercentage,
    startOfCurrentWeek
  } = useWeeklyData(weekOffset, routines, routineProgress);

  return (
    <div className="w-full space-y-1 text-foreground dark:text-white/80">
      <GraphHeader 
        totalCompletedRoutines={totalCompletedRoutines}
        progressPercentage={progressPercentage}
      />
      <RoutineBarChart weekDays={weekDays} />
      <WeekNavigation 
        startOfCurrentWeek={startOfCurrentWeek}
        weekOffset={weekOffset}
        onPreviousWeek={() => setWeekOffset(prev => prev + 1)}
        onNextWeek={() => setWeekOffset(prev => Math.max(0, prev - 1))}
      />
    </div>
  );
};